import { render, staticRenderFns } from "./vivaCenterList.vue?vue&type=template&id=6d9ab86e&"
import script from "./vivaCenterList.vue?vue&type=script&lang=js&"
export * from "./vivaCenterList.vue?vue&type=script&lang=js&"
import style0 from "./vivaCenterList.vue?vue&type=style&index=0&id=6d9ab86e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports